import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { logAnalyticsEvent } from '@vestico/utils';

import { SupportedMatchInfoHashCategory, isBeautyMatchingCategory } from '@vestico/model';

import { Button } from '@vestico/shared';

import globalStyle from '../../../layouts/utils.module.css';
import style from './InlineEnterMatchInfoCTA.module.css';

export interface InlineEnterMatchInfoCTAProps {
  onClick: () => void;
  category?: SupportedMatchInfoHashCategory;
  clientID: string;
}

export const InlineEnterMatchInfoCTA = ({ onClick, category, clientID }: InlineEnterMatchInfoCTAProps) => {
  const { t } = useTranslation('shared');

  const handleClick = useCallback(() => {
    onClick();
    logAnalyticsEvent({ category: 'event', event: 'showcase-cta', dimensions: { provider: clientID } });
  }, [clientID, onClick]);

  const smallText = useMemo(
    () =>
      isBeautyMatchingCategory(category)
        ? t('LOC_SHOWCASE_ENTER_SKIN_INFO_TEXT', { ns: 'shared' })
        : t('LOC_SHOWCASE_ENTER_BODY_INFO_TEXT', { ns: 'shared' }),
    [t, category]
  );

  return (
    <div className={clsx(style.root)}>
      <div className={clsx(globalStyle.textSmall, globalStyle.textBold, globalStyle.textColorMuted)}>{smallText}</div>
      <div>
        <Button content={t('LOC_SHOWCASE_ENTER_BODY_INFO_BUTTON', { ns: 'shared' })} onClick={handleClick} />
      </div>
    </div>
  );
};
